module.exports = __webpack_public_path__ + "img/fzlc.465a8030.png";